import React, { FC } from 'react';
import classes from './styles/index.module.scss';
import { FlexBox } from "../../../FlexBox";
import { Text } from "../../../Text";
import { DropdownValueType } from "../../types";
import { CheckMark } from "../../../../icons/CheckMark";
import classNames from "classnames";

type DropdownItemType = {
    item: DropdownValueType,
    isSelected: boolean,
    onClick: () => void,
}

export const DropdownItem: FC<DropdownItemType> = (
    { item, isSelected, onClick }
) => {
    const handleClick = () => {
        !item.isDisabled && onClick();
    };
    const itemClasses = classNames(classes.dropdownItem, {
        [classes.dropdownItem_disabled]: item.isDisabled,
    });

    return (
        <div onClick={handleClick} className={itemClasses}>
            <FlexBox justify='space-between' align='middle' style={{ height: '100%' }}>
                <Text weight='semiBold' className={classes.dropdownItem_text}>{item.title}</Text>
                {isSelected && (
                    <CheckMark className={classes.checkMark}/>
                )}
            </FlexBox>
        </div>
    );
}